import React from 'react';
import { CardContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useIntl } from 'react-intl';
import { useResourceOverviewToolbarContext } from '~/modules/resource-management/ResourceManagementDashboard/hooks/useResourceManagementDashboardContext';
import { useResourceManagementContext } from '~/modules/resource-management/common';
import useFilterBasedOnSearchCriteria from '~/modules/resourcing/hooks/useFilterBasedOnSearchCriteria';
import {
  useGetFormattedActionItemsContent,
  useGetActionItemsData
} from '../hooks';
import ActionItemLink from './ActionItemLink';

const useStyles = makeStyles(theme => ({
  cardContent: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    gap: theme.spacing(2),
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'start',
      flexDirection: 'row'
    }
  }
}));

const useColourStyles = makeStyles(theme => ({
  benchCard: {
    background: `linear-gradient(100.75deg, ${theme.palette.resourceAllocation.bench} -43%, ${theme.palette.text.white} 100%)`
  },
  overAllocatedCard: {
    background: `linear-gradient(100.75deg, ${theme.palette.resourceAllocation.overAllocated} -43%, ${theme.palette.text.white} 100%)`
  },
  pendingRequestsCard: {
    background: `linear-gradient(100.75deg, ${theme.palette.resourceRequest.pending.main} -43%, ${theme.palette.text.white} 100%)`
  },
  proposedResourcesCard: {
    background: `linear-gradient(100.75deg, ${theme.palette.resourceRequest.proposed.main} -43%, ${theme.palette.text.white} 100%)`
  },
  toBeHiredCard: {
    background: `linear-gradient(100.75deg, ${theme.palette.resourceRequest.toBeHired.main} -43%, ${theme.palette.text.white} 100%)`
  }
}));

export const ActionItemsCardContent = () => {
  const classes = useStyles();
  const colourClasses = useColourStyles();
  const { formatMessage } = useIntl();

  const {
    dateRange,
    periodScale,
    displayUnit
  } = useResourceOverviewToolbarContext();
  const { searchCriteria } = useResourceManagementContext();
  const { filter } = useFilterBasedOnSearchCriteria({ searchCriteria });

  const { loading: isLoading, actionItemValues } = useGetActionItemsData({
    dateRange,
    periodScale,
    displayUnit,
    filter
  });

  const formattedActionItems = useGetFormattedActionItemsContent({
    colourClasses,
    formatMessage,
    actionItemValues,
    displayUnit
  });

  return (
    <CardContent className={classes.cardContent}>
      {formattedActionItems.map(actionItem => (
        <ActionItemLink
          key={actionItem.key}
          actionItem={actionItem}
          isLoading={isLoading}
        />
      ))}
    </CardContent>
  );
};

export default ActionItemsCardContent;
